module.exports = __webpack_public_path__ + "img/woyaotie.ac273ea7.png";